import { fetchRegions } from '../../services/api/common';

export const regions = {
    namespaced: true,
    state: {
        regions: [],
    },
    mutations: {
        save(state, data) {
            state.regions = data;
        }
    },
    actions: {
        fetchRegions({ commit, dispatch }, values) {
            return fetchRegions()
                .then((res) => {
                    commit('save', res.data);
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    throw res;
                });
        }
    },
    getters: {
        regions({ regions }) {
            return regions;
        },

        isFetched({ regions }) {
            return !!regions.length;
        }
    }
};



// WEBPACK FOOTER //
// ./src/modules/regions/store.js